import { ButtonMantine, ButtonProps } from '../../Buttons/ButtonMantine';
import { Currency } from '../../Inputs';
import { Group, Stack } from '../../Layout';
import { Center } from '../../Layout/Center';
import { Text } from '../../Typography';
import { useButtonGroupContext } from './ButtonGroup/useButtonGroup';

interface CurrencyButtonProps extends ButtonProps {
  label?: string;
  value: number | '';
  onClick?: (value: number | '') => void;
}

const CurrencyButton = (props: CurrencyButtonProps) => {
  const { label, value } = props;
  const context = useButtonGroupContext();

  const contextProps = context
    ? {
        onclick: context.onClick,
        value: context.value,
        activeButton: context.activeButton,
      }
    : {};

  const onClick = () => {
    if (!value) return;
    if (contextProps.onclick) {
      contextProps.onclick({ value, label });
    } else if (props.onClick) {
      props.onClick(value);
    }
  };

  const active = label
    ? contextProps.activeButton?.value == value && contextProps.activeButton?.label == label
    : contextProps.activeButton?.value == value;

  return (
    <ButtonMantine
      {...props}
      value={value}
      fullWidth
      onClick={onClick}
      data-active={active}
      styles={{ label: { width: '100%', overflow: 'visible' } }}
    >
      <Group w="100%" wrap="nowrap" gap="sm" justify={label ? 'space-between' : 'center'}>
        {label && (
          <Text fz="xs" fw={400} style={{ whiteSpace: 'break-spaces' }}>
            {label}
          </Text>
        )}
        <Stack gap={0}>
          <Currency value={value}>{(props) => <Center>${props.value}</Center>}</Currency>
          {label === undefined && (
            <Text fz="xs" fw={400}>
              USD
            </Text>
          )}
        </Stack>
      </Group>
    </ButtonMantine>
  );
};

export { CurrencyButton };
